import React from 'react';
import { motion } from 'framer-motion';
import { BuyButton } from './BuyButton';
import { ShieldCheck, Zap, Download } from 'lucide-react';
export const Hero: React.FC = () => {
  const scrollToPurchase = () => {
    document.getElementById('purchase-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-navy text-white min-h-screen flex items-center px-4 sm:px-6 lg:px-8 py-6 sm:py-12 relative overflow-hidden" data-id="element-74">
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-75">
        <div className="absolute w-96 h-96 bg-lavender rounded-full blur-3xl -top-20 -left-20" data-id="element-76"></div>
        <div className="absolute w-96 h-96 bg-accent rounded-full blur-3xl -bottom-20 -right-20" data-id="element-77"></div>
      </div>

      <div className="text-center max-w-4xl mx-auto relative z-10 w-full" data-id="element-78">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-yellow-400 font-bold tracking-wider uppercase text-xs sm:text-base mb-3 sm:mb-4" data-id="element-79">
          Abordaje del Insomnio en Ansiedad y Depresión
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="font-serif text-2xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4 sm:mb-6" data-id="element-80">
          COMENZÁ HOY CON EL ABORDAJE DEL INSOMNIO EN PACIENTES CON CUADROS
          DEPRESIVOS Y/O ANSIOSOS
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="text-sm sm:text-lg text-gray-300 mb-5 sm:mb-8 max-w-3xl mx-auto" data-id="element-81">
          Protocolos específicos para intervenir el sueño en pacientes con
          ansiedad, rumiación nocturna, fatiga emocional y estado de ánimo bajo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3
      }} className="relative mx-auto max-w-[240px] sm:max-w-sm mb-5 sm:mb-8 cursor-pointer" onClick={scrollToPurchase} data-id="element-82">
          <img src="https://cdn.magicpatterns.com/uploads/fuzX4hNhsp7kksCY7iEMam/Diseno_sin_titulo_(31).png" alt="Kit Insomnio en Ansiedad y Depresión" className="w-full h-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300" data-id="element-83" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-84">
          <BuyButton className="mb-4 sm:mb-6" data-id="element-85" />

          <div className="flex flex-wrap justify-center gap-3 sm:gap-6 text-xs sm:text-sm text-lavender-muted font-medium" data-id="element-86">
            <div className="flex items-center gap-2" data-id="element-87">
              <Zap className="w-4 h-4 sm:w-5 sm:h-5 text-lavender" data-id="element-88" />
              <span data-id="element-89">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-90">
              <ShieldCheck className="w-4 h-4 sm:w-5 sm:h-5 text-lavender" data-id="element-91" />
              <span data-id="element-92">Pago único y seguro</span>
            </div>
            <div className="hidden sm:flex items-center gap-2" data-id="element-93">
              <Download className="w-5 h-5 text-lavender" data-id="element-94" />
              <span data-id="element-95">Descargás. Aplicás.</span>
            </div>
          </div>
          <p className="mt-2 sm:mt-4 text-white font-semibold text-sm sm:text-base" data-id="element-96">
            Intervenís con más precisión clínica.
          </p>
        </motion.div>
      </div>
    </section>;
};